<template>
  <div>
    <v-slide-x-reverse-transition group :style="style" class="wrapper align-center justify-end layout">
      <div key="circle" :style="circle" class="circle mr-2" />
      <div v-if="usedStatus" key="status">
        {{ usedStatus.name }}
      </div>
    </v-slide-x-reverse-transition>
  </div>
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'StatusView',
  filters: {
    readable: function(e) {
      return e.replace('_', ' ').toUpperCase();
    }
  },
  props: {
    small: Boolean,
    slideId: String,
    status: String,
    statusId: String
  },
  data() {
    return {
      workflowStatus: null
    };
  },
  computed: {
    usedStatus() {
      return this.workflowStatus || this.status;
    },
    style() {
      return {
        color: this.workflowStatus ? this.workflowStatus.color : `var(--${this.status}) !important`,
        fontWeight: 'bold'
      };
    },
    circle() {
      return {
        backgroundColor: this.workflowStatus ? this.workflowStatus.color : `var(--${this.status}) !important`
      };
    }
  },
  apollo: {
    $subscribe: {
      status: {
        query: gql`
          subscription status($slideId: ID) {
            status: slideStatus(slideId: $slideId) {
              status {
                name
                color
                actions {
                  _id
                  name
                  priority
                  target {
                    _id
                  }
                }
              }
            }
          }
        `,
        result(data) {
          this.workflowStatus = data.data.status.status;
        },
        variables() {
          return {
            slideId: this.slideId
          };
        }
      }
    },
    workflowStatus: {
      skip() {
        return !this.statusId;
      },
      query: gql`
        query($id: ID!) {
          getWorkflowStatus(id: $id) {
            name
            color
            actions {
              _id
              name
              priority
              target {
                _id
              }
            }
          }
        }
      `,
      update: data => data.getWorkflowStatus,
      variables() {
        return {
          id: this.statusId
        };
      }
    }
  }
};
</script>

<style scoped>
.circle {
  width: 18px;
  height: 18px;
  background-color: inherit;
  border-radius: 50%;
}
</style>
